import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookNumericFormatInputWrapper } from 'src/components/CookbookNumericFormatInputWrapper/CookbookNumericFormatInputWrapper';
import { getFeeValidation } from 'src/components/enterprise/features/Corporate/components/Form/utils/feeValidation.utils';

export interface TransactionFeeFieldProps {
  name: string;
  id: string;
}

export function TransactionFeeField({
  name,
  id,
}: TransactionFeeFieldProps): JSX.Element {
  const { errors, control } = useFormContext();
  const label = 'Transaction Fee';
  const validate = getFeeValidation({
    label,
  });

  return (
    <CookbookNumericFormatInputWrapper
      name={name}
      id={id}
      control={control}
      error={errors[name]}
      inputSize="medium"
      maxFractionalDigits={2}
      blockWidth
      label={`${label} *`}
      placeholder="e.g. 5"
      suffixDecorator="%"
      rules={{
        required: `${label} is required`,
        validate,
      }}
    />
  );
}
